import styled, { css } from "styled-components";
import { breakpoints } from "../../../../../shared-logic/themes/toyotaTheme";

export const Wrapper = styled.div<{ open?: boolean; isSlideOut?: boolean; isSlideIn?: boolean; isRetailer?: boolean }>`
    display: none;
    flex-direction: column;
    row-gap: var(--spacing-1);
    background-color: var(--color-highlight-black);
    border-radius: 16px;

    @keyframes slideInBottom {
        0% {
            transform: ${({ isRetailer }) => (isRetailer ? "translateY(350%)" : "translateY(150%)")};
        }
        100% {
            transform: translateY(0);
        }
    }

    @keyframes slideOutBottom {
        0% {
            transform: translateY(0);
        }
        100% {
            transform: ${({ isRetailer }) => (isRetailer ? "translateY(350%)" : "translateY(150%)")};
        }
    }

    @media screen and (min-width: ${breakpoints.lg}) {
        display: flex;
    }

    ${({ open }) =>
        open &&
        css`
            animation: slideInBottom forwards 0.5s;
        `};

    ${({ isSlideIn }) =>
        isSlideIn &&
        css`
            animation: slideInBottom forwards 0.5s;
        `};

    ${({ isSlideOut }) =>
        isSlideOut &&
        css`
            animation: slideOutBottom forwards 0.5s;
        `};
`;

export const Content = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: var(--spacing-3);
    max-width: 100%;
    padding-block: calc(var(--spacing-3) / 2);
    padding-inline: var(--spacing-2);
    color: var(--color-primary-white);

    @media screen and (min-width: ${breakpoints.md}) {
        column-gap: var(--spacing-5);
    }

    @supports not (padding-block: 0) {
        padding: calc(var(--spacing-3) / 2) var(--spacing-2);
    }

    @supports not (gap: 0) {
        div {
            margin-left: var(--spacing-3);

            @media (min-width: ${breakpoints.md}) {
                margin-left: var(--spacing-5);
            }
        }
    }
`;

export const Actions = styled.div`
    display: flex;
    align-items: center;
    column-gap: var(--spacing-1);

    a,
    button {
        flex-shrink: 0;
    }

    @supports not (gap: 0) {
        a,
        button {
            margin-left: var(--spacing-1);
        }
    }
`;
